var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lifetime-warranty-list',_vm._b({},'lifetime-warranty-list',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }